module.exports = ["Dancer","Musician","Visual Artist","Cinematographer"]


//////////////////
// WEBPACK FOOTER
// ./src/assets/profession.json
// module id = T7gG
// module chunks = 1